import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/payments/payment-allocation/:allocationId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    allocationId: string;
}
const mutationFn = ({ allocationId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { allocationId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeletePaymentAllocation };
